/* Eterna — "In play" films (27.09.2026). Click-to-play with sound, one film at a time, progress bar, mute toggle,
   mobile strip with arrows and counter, and (where the section enables it) a large view: pressing play moves the
   tile's frame into a fixed overlay so the film is watched at up to the viewport's height, with the reviewer's words
   (a <template> in the tile) to the right of it; Esc / × / backdrop close it.
   The play state lives on the frame as well as the tile, because the frame leaves the tile while the large view is open. Shared by sections/et-in-play.liquid (homepage row) and
   sections/et-pdp-in-play.liquid (product page). Tiles are rendered by snippets/et-in-play-tile.liquid. */
(function () {
  'use strict';
  if (window.etInPlay) return;
  var tiles = [];
  var lightbox = null;
  var lbState = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    var el = document.createElement('div');
    el.className = 'et-ip-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.hidden = true;
    el.innerHTML = '<div class="et-ip-lightbox__backdrop" data-et-ip-close></div>' +
      '<div class="et-ip-lightbox__panel"><div class="et-ip-lightbox__media"><div class="et-ip-lightbox__stage" data-et-ip-stage></div><div class="et-ip-lightbox__caption" data-et-ip-lb-caption></div></div><div class="et-ip-lightbox__review" data-et-ip-lb-review></div></div>' +
      '<button type="button" class="et-ip-lightbox__close" data-et-ip-close aria-label="' + (document.body.getAttribute('data-et-ip-close-label') || 'Close') + '">' +
      '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round"></path></svg></button>';
    document.body.appendChild(el);
    el.querySelectorAll('[data-et-ip-close]').forEach(function (b) { b.addEventListener('click', function () { closeLightbox(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) closeLightbox(); });
    lightbox = el;
    return el;
  }

  function openLightbox(tile) {
    if (lbState && lbState.tile === tile) return;
    if (lbState) closeLightbox();
    var el = ensureLightbox();
    var frame = tile.querySelector('.et-ip__frame');
    if (!frame) return;
    var ghost = document.createElement('div');
    ghost.className = 'et-ip__ghost';
    frame.parentNode.insertBefore(ghost, frame);
    el.querySelector('[data-et-ip-stage]').appendChild(frame);
    var cap = el.querySelector('[data-et-ip-lb-caption]');
    cap.textContent = '';
    var name = tile.querySelector('.et-ip__name'), line = tile.querySelector('.et-ip__line');
    if (name) { var n = document.createElement('span'); n.className = 'et-ip-lightbox__name'; n.textContent = name.textContent; cap.appendChild(n); }
    if (line) { var l = document.createElement('span'); l.className = 'et-ip-lightbox__line'; l.textContent = line.textContent; cap.appendChild(l); }
    var rev = el.querySelector('[data-et-ip-lb-review]');
    var tpl = tile.querySelector('template[data-et-ip-review]');
    rev.textContent = '';
    if (tpl && tpl.content) { rev.appendChild(tpl.content.cloneNode(true)); el.classList.add('has-review'); } else { el.classList.remove('has-review'); }
    var img = frame.querySelector('.et-ip__poster');
    if (img) { if (!img.dataset.etSizes) img.dataset.etSizes = img.sizes || ''; img.sizes = '(min-width: 750px) 34rem, 92vw'; }
    var video = frame.querySelector('video');
    if (video && video.dataset.hd && !video.dataset.hdSet && window.innerHeight > 900) {
      var src = video.querySelector('source');
      if (src) { src.setAttribute('src', video.dataset.hd); video.dataset.hdSet = '1'; video.load(); }
    }
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.classList.add('et-ip-lock');
    lbState = { tile: tile, frame: frame, ghost: ghost };
    var closeBtn = el.querySelector('.et-ip-lightbox__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeLightbox() {
    if (!lbState) return;
    var s = lbState;
    lbState = null;
    if (typeof s.tile.etReset === 'function') s.tile.etReset();
    var img = s.frame.querySelector('.et-ip__poster');
    if (img && img.dataset.etSizes !== undefined) img.sizes = img.dataset.etSizes;
    if (s.ghost.parentNode) { s.ghost.parentNode.insertBefore(s.frame, s.ghost); s.ghost.parentNode.removeChild(s.ghost); }
    if (lightbox) {
      lightbox.classList.remove('is-open');
      lightbox.classList.remove('has-review');
      var rev = lightbox.querySelector('[data-et-ip-lb-review]');
      if (rev) rev.textContent = '';
      lightbox.hidden = true;
    }
    document.documentElement.classList.remove('et-ip-lock');
    var play = s.tile.querySelector('[data-et-ip-play]');
    if (play) play.focus({ preventScroll: true });
  }

  function fmt(t) {
    t = Math.max(0, Math.round(t || 0));
    var m = Math.floor(t / 60), s = t % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function setupTile(tile) {
    var video = tile.querySelector('video');
    if (!video) return;
    var playBtn = tile.querySelector('[data-et-ip-play]');
    var pauseBtn = tile.querySelector('[data-et-ip-pause]');
    var soundBtn = tile.querySelector('[data-et-ip-sound]');
    var fill = tile.querySelector('[data-et-ip-fill]');
    var time = tile.querySelector('[data-et-ip-time]');
    var track = tile.querySelector('[data-et-ip-track]');

    var frame = tile.querySelector('.et-ip__frame') || tile;
    function setState(s) { tile.setAttribute('data-et-ip-state', s); frame.setAttribute('data-et-ip-state', s); }
    function syncSound() {
      if (!soundBtn) return;
      soundBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      [tile, frame].forEach(function (el) { if (video.muted) el.setAttribute('data-et-ip-muted', ''); else el.removeAttribute('data-et-ip-muted'); });
    }
    function start() {
      tiles.forEach(function (t) { if (t !== tile) t.etReset(); });
      if (tile.etLightbox) openLightbox(tile);
      video.muted = false;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          video.muted = true;
          syncSound();
          var q = video.play();
          if (q && typeof q.catch === 'function') q.catch(function () {});
        });
      }
    }
    tile.etReset = function () {
      if (!video.paused) video.pause();
      try { if (video.currentTime > 0) video.currentTime = 0; } catch (e) {}
      if (fill) fill.style.width = '0%';
      if (time && video.duration) time.textContent = fmt(video.duration);
      setState('idle');
    };

    if (playBtn) playBtn.addEventListener('click', function (e) { e.preventDefault(); start(); });
    if (pauseBtn) pauseBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); video.pause(); });
    if (soundBtn) soundBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); video.muted = !video.muted; syncSound(); });
    video.addEventListener('click', function () { if (video.paused) start(); else video.pause(); });
    video.addEventListener('volumechange', syncSound);
    video.addEventListener('play', function () { setState('playing'); });
    video.addEventListener('pause', function () { if (!video.ended && video.currentTime > 0) setState('paused'); });
    video.addEventListener('ended', function () { tile.etReset(); });
    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      if (fill) fill.style.width = (video.currentTime / video.duration * 100).toFixed(2) + '%';
      if (time) time.textContent = fmt(video.duration - video.currentTime);
    });
    if (track) track.addEventListener('click', function (e) {
      e.stopPropagation();
      var r = track.getBoundingClientRect();
      if (!video.duration || !r.width) return;
      var k = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      try { video.currentTime = k * video.duration; } catch (err) {}
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (!en.isIntersecting && !video.paused) video.pause(); });
      }, { threshold: 0.3 }).observe(tile);
    }
    tile.etLightbox = !!tile.closest('[data-et-ip-lightbox]');
    tiles.push(tile);
  }

  function setupStrip(strip) {
    var root = strip.closest('[data-et-ip]') || document;
    var items = strip.querySelectorAll('[data-et-ip-tile]');
    var current = root.querySelector('[data-et-ip-current]');
    function step() {
      var w = items[0] ? items[0].getBoundingClientRect().width : 0;
      var cs = getComputedStyle(strip);
      var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
      return w + gap;
    }
    function index() { var s = step(); return s ? Math.round(strip.scrollLeft / s) : 0; }
    strip.addEventListener('scroll', function () {
      if (current) current.textContent = Math.min(items.length, index() + 1);
    }, { passive: true });
    root.querySelectorAll('[data-et-ip-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-et-ip-dir'), 10) || 1;
        var i = Math.min(items.length - 1, Math.max(0, index() + dir));
        strip.scrollTo({ left: i * step(), behavior: 'smooth' });
      });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-et-ip-tile]').forEach(function (t) { if (!t.etIpReady) { t.etIpReady = true; setupTile(t); } });
    root.querySelectorAll('[data-et-ip-strip]').forEach(function (s) { if (!s.etIpReady) { s.etIpReady = true; setupStrip(s); } });
  }

  window.etInPlay = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
